import { Link } from "react-router-dom";
import { getCategory } from "@/mocks/categories";
import { byCat } from "@/mocks/items";
import SectionHeading from "@/components/base/SectionHeading";

const rows = [
  { slug: "renwu", icon: "ri-user-heart-line" },
  { slug: "jigou", icon: "ri-building-4-line" },
];

export default function PeopleOrgStrip() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="人物 · 机构"
          title="看见人，也看见平台"
          desc="人物动态与机构观察，双重视角补齐你对行业风向的判断。"
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {rows.map((row) => {
            const cat = getCategory(row.slug);
            const list = byCat(row.slug).slice(0, 2);
            if (!cat) return null;
            return (
              <div key={row.slug} className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
                <div className="flex items-center gap-3 border-b border-background-200 px-5 py-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-700">
                    <i className={row.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                    <p className="text-xs text-foreground-500">{cat.tagline}</p>
                  </div>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="ml-auto inline-flex shrink-0 cursor-pointer items-center gap-1 rounded-full bg-background-200 px-3.5 py-1.5 text-xs font-semibold text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    全部 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="flex flex-col divide-y divide-background-100">
                  {list.map((item) => (
                    <Link
                      key={item.id}
                      to={`/item/${item.id}`}
                      className="group flex cursor-pointer items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100"
                    >
                      <img
                        src={item.cover}
                        alt={item.title}
                        className="h-14 w-20 shrink-0 rounded-md object-cover"
                      />
                      <div className="min-w-0">
                        <h4 className="font-heading text-sm leading-snug font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-700 md:text-base">
                          {item.title}
                        </h4>
                        <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-500">
                          <i className="ri-time-line"></i>{item.time}
                          <i className="ri-eye-line ml-2"></i>{item.reads}
                        </span>
                      </div>
                      <i className="ri-arrow-right-s-line ml-auto shrink-0 text-xl text-foreground-300 group-hover:text-primary-500"></i>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}